import styled from 'styled-components';
import PropTypes from 'prop-types';

import { overlays, overlayOrder } from '../../design/theme';

const getHiddenPercentage = ({ isVisible, enterFrom }) => {
  const hiddenPercentage = enterFrom === 'top' ? -100 : 100;
  return isVisible ? 0 : hiddenPercentage;
};

const Drawer = styled.div`
  top: ${(props) => (props.enterFrom === 'top' ? 0 : null)};
  bottom: ${(props) => (props.enterFrom === 'bottom' ? 0 : null)};
  left: 0;
  right: 0;
  transform: translateY(${getHiddenPercentage}%);
  transition: 0.25s transform ease-in-out, 0.25s opacity ease-in-out;
  opacity: ${(props) => (props.isVisible ? 1 : 0)}.0;
  position: fixed;
  z-index: ${(props) => overlayOrder.indexOf(props.overlay)};
`;

Drawer.propTypes = {
  ...Drawer.propTypes,
  enterFrom: PropTypes.oneOf(['top', 'bottom']).isRequired,
  isVisible: PropTypes.bool,
  overlay: PropTypes.string.isRequired,
};

Drawer.defaultProps = {
  ...Drawer.defaultProps,
  isVisible: false,
  overlay: overlays.DEFAULT,
};

Drawer.displayName = 'Drawer';

export default Drawer;
